import { useMemo } from 'react';

// components
import { CasEditForm, IEditForm } from 'src/compass/shared/components';

import { CasRHFUserSelect } from 'src/compass/application';
// schema
import { EmployeeSchema } from '../EmployeeSchema';
import EmployeeFields from '../EmployeeFields';

// ----------------------------------------------------------------------

export default function EmployeeForm({ row, onSaved }: IEditForm) {
  const { id } = row || {};

  const defaultValues = useMemo(
    () => (id ? row : { isActive: true }),
    [id, row]
  );

  return (
    <CasEditForm
      defaultValues={defaultValues}
      onSaved={onSaved}
      entity="Employee"
      schema={EmployeeSchema}
    >
      {/* Users not linked to another Employee: a user can be only one */}
      <CasRHFUserSelect
        name="userId"
        label="User"
        includeNoneOption
        params={{ forEmployeeId: id ?? 0 }}
      />

      <EmployeeFields />
    </CasEditForm>
  );
}
